import { BODY, PAGE, PROFILE, RETOKEN, TOKEN } from '../Constants'
import { MENU_LOGIN } from '../router/routes'
import SwalCustom from '../alert/swal-custom'

function SwalErrorToken() {
  SwalCustom({
    title: 'Token time out.',
    text: 'User not found authenticate',
    icon: 'info',
    showCancelButton: false,
    confirmButtonColor: '#2C5DFE',
    confirmButtonText: 'Close'
  }).then(() => {
    localStorage.removeItem(TOKEN)
    localStorage.removeItem(RETOKEN)
    localStorage.removeItem(PROFILE)
    localStorage.removeItem(PAGE)
    localStorage.removeItem(BODY)
    window.open(MENU_LOGIN, '_self')
  })
}

export default SwalErrorToken
